// ignore-string-externalization
import { makeContentfulAsset } from '../Contentful';
import { youtubeIdRegex } from '../utils';
export function youtubeThumbnailUrl(rawVideoUrl) {
  var _rawVideoUrl$split$;

  var videoUrl = rawVideoUrl === null || rawVideoUrl === void 0 ? void 0 : (_rawVideoUrl$split$ = rawVideoUrl.split('#')[0]) === null || _rawVideoUrl$split$ === void 0 ? void 0 : _rawVideoUrl$split$.trim();

  if (!videoUrl) {
    return undefined;
  }

  var videoId = youtubeIdRegex.exec(videoUrl);
  return videoId && videoId[1] ? "https://img.youtube.com/vi/".concat(videoId[1], "/maxresdefault.jpg") : undefined;
}
export var socialCardImageHandlers = {
  landingPage: function landingPage(template) {
    var socialCard = template.socialCard;

    if (!socialCard) {
      if ('heroModule' in template) {
        var hm = template.heroModule;

        if (hm) {
          var _hm$carouselSlides$;

          return hm.image || 'carouselSlides' in hm && ((_hm$carouselSlides$ = hm.carouselSlides[0]) === null || _hm$carouselSlides$ === void 0 ? void 0 : _hm$carouselSlides$.image);
        }
      }
    }

    return socialCard;
  },
  articlePage: function articlePage(template) {
    var headerModule = template === null || template === void 0 ? void 0 : template.headerModule;
    return headerModule === null || headerModule === void 0 ? void 0 : headerModule.image;
  },
  videoPage: function videoPage(template) {
    var thumbnailImage = template.thumbnailImage;

    if (thumbnailImage) {
      return thumbnailImage;
    }

    var video = template === null || template === void 0 ? void 0 : template.video;
    var url = youtubeThumbnailUrl(video === null || video === void 0 ? void 0 : video.videoUrl);
    return url && makeContentfulAsset({
      url: url,
      contentType: 'image/jpeg',
      width: 1280,
      height: 720,
      description: video === null || video === void 0 ? void 0 : video.title
    });
  },
  helpHomePage: getHelpSocialCard,
  typeformPage: function typeformPage() {
    return null;
  }
};
export function getTemplateSocialCardAsset(template) {
  var findSocialCardImage = socialCardImageHandlers[template.contentType];
  return findSocialCardImage ? findSocialCardImage(template) : undefined;
}
export function getTemplateSocialCardUrl(template) {
  var _asset$file, _asset$file$contentTy, _asset$file2;

  var asset = getTemplateSocialCardAsset(template);
  return typeof asset === 'object' ? (asset === null || asset === void 0 ? void 0 : (_asset$file = asset.file) === null || _asset$file === void 0 ? void 0 : (_asset$file$contentTy = _asset$file.contentType) === null || _asset$file$contentTy === void 0 ? void 0 : _asset$file$contentTy.startsWith('image/')) && (asset === null || asset === void 0 ? void 0 : (_asset$file2 = asset.file) === null || _asset$file2 === void 0 ? void 0 : _asset$file2.url) : asset;
}

function getHelpSocialCard() {
  var url = '/S4ALogo.jpg';
  return makeContentfulAsset({
    url: url,
    contentType: 'image/jpeg',
    width: 1280,
    height: 720,
    description: 'Spotify for Artists - Help'
  });
}